module.exports = __webpack_public_path__ + "static/media/game_cover_slidey.982ae7e3.png";